import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GamesHub.css';

const GAMES = [
  { title: '2048', description: 'Merge tiles to reach 2048. Swipe or use arrow keys.', icon: '🔢', route: '/demo/2048', color: '#edc22e' },
  { title: 'Slide Puzzle', description: 'Arrange numbered tiles in order. 3×3 to 6×6 modes.', icon: '🧩', route: '/demo/puzzle', color: '#7c83ff' },
  { title: 'Memory Match', description: 'Flip cards to find matching pairs. Multiple themes.', icon: '🃏', route: '/demo/memory', color: '#e040fb' },
  { title: 'Snake', description: 'Classic snake game. Eat food, grow longer, don\'t crash.', icon: '🐍', route: '/demo/snake', color: '#00c853' },
  { title: 'Wordle', description: 'Guess the 5-letter word in 6 tries with color hints.', icon: '📝', route: '/demo/wordle', color: '#538d4e' },
  { title: 'Tic-Tac-Toe', description: 'Play against an unbeatable AI or a friend. 3 difficulties.', icon: '❌', route: '/demo/tictactoe', color: '#4facfe' },
];

function GamesHub() {
  const navigate = useNavigate();

  return (
    <div className="ghub-app">
      <div className="ghub-topbar">
        <button className="ghub-back-btn" onClick={() => navigate('/')}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 className="ghub-title">Games Arcade</h1>
        <span className="ghub-count">{GAMES.length} games</span>
      </div>

      <div className="ghub-container">
        <div className="ghub-grid">
          {GAMES.map((game) => (
            <div
              key={game.route}
              className="ghub-card"
              onClick={() => navigate(game.route)}
              style={{ '--game-color': game.color }}
            >
              <div className="ghub-card-icon" style={{ background: game.color + '20' }}>
                <span>{game.icon}</span>
              </div>
              <div className="ghub-card-body">
                <h3>{game.title}</h3>
                <p>{game.description}</p>
              </div>
              <div className="ghub-card-arrow">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GamesHub;
